export const i18nHomePage = {
  summary: {
    production: 'Production',
    uptime: 'Uptime',
    savings: 'Savings',
    co: 'CO²e',
    so: 'SO²',
    health: 'Health',
  },
  card: {
    labels: {
      empty: 'No Alarms',
      closed: 'No Alarms',
      open: 'Alarms',
      investigating: 'Investigating',
      no_data: 'No data',
      delay: 'Sensors delay',
      active: 'Sensors ok',
    },
  },
};
